/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "./src/styles/vendor.scss"
import "./src/styles/global.scss"

// You can delete this file if you're not using it
